import { CHANGE_FAVORITE_AMOUNT } from '../favoriteAmounts';
export function changeFavoriteBetAmount(data) {
    return function (dispatch) { return dispatch({ type: CHANGE_FAVORITE_AMOUNT, data: data }); };
}



// WEBPACK FOOTER //
// ./src/actions/creators/favoriteAmounts.js